










import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { guid } from '@/utils';
import {
    IStatsOfficePeriodChartModel,
    IStatOfficePeriodChartItemModel,
    ChartGroupBy
} from '@/entities';

import Vue from 'vue';
import Top10Criteria from './top10-criteria.vue';
import statsApi from '@/api/stats.api';

declare var CanvasJS: any;

@Component({})
export default class OfficeChart extends Vue {
    @Prop() public model: IStatsOfficePeriodChartModel;
    @Prop() public groupBy: ChartGroupBy;

    private chart: any;

    get chartDivId() {
        return 'chart' + guid();
    }

    public mounted() {
        this.chart = new CanvasJS.Chart(this.chartDivId, {
            theme: 'theme3',
            title: {
                text: 'not set'
            },
            dataPointMaxWidth: 39,
            animationEnabled: true,
            toolTip: {
                shared: true,
                content: (e) => {
                    const head =
                        `<span style = 'color:DodgerBlue; '><strong>` +
                        e.entries[0].dataPoint.label +
                        '</strong></span><br/>';

                    const body =
                        `<span style= 'color:` +
                        e.entries[0].dataSeries.color +
                        `'> ` +
                        e.entries[0].dataSeries.name +
                        '</span>: <strong>' +
                        e.entries[0].dataPoint.y +
                        '</strong>  <!--m/s--><br/>' +
                        (e.entries.length > 1
                            ? `<span style= 'color:` +
                              e.entries[1].dataSeries.color +
                              `'> ` +
                              e.entries[1].dataSeries.name +
                              '</span>: <strong>' +
                              e.entries[1].dataPoint.y +
                              '</strong>'
                            : '');

                    return head.concat(body);
                }
            },
            axisY: {
                title: 'Sales',
                includeZero: false,
                suffix: '',
                lineColor: '#375a7f'
            },
            axisY2: {
                title: 'Progress',
                includeZero: false,
                suffix: '%',
                lineColor: '#C24642'
            },
            axisX: {
                title: 'Monthly',
                suffix: ' '
            },
            data: [
                {
                    // Change type to "doughnut", "line", "splineArea", etc.
                    type: 'column',
                    dataPoints: [{ x: 0, y: 10 }, { x: 1, y: 15 }]
                }
            ]
        });
        if (this.model != null) {
            this.applyModel(this.model);
        }

        this.chart.render();
    }

    @Watch('groupBy')
    private onGroupByChanged(val: ChartGroupBy, oldVal: ChartGroupBy) {
        this.chart.options.axisX.text =
            val === ChartGroupBy.day ? 'Daily' : 'Montly';
        this.chart.render();
    }

    @Watch('model')
    private onModelChanged(
        val: IStatsOfficePeriodChartModel,
        oldVal: IStatsOfficePeriodChartModel
    ) {
        this.applyModel(val);
        this.chart.render();
    }

    private applyModel(model: IStatsOfficePeriodChartModel) {
        this.chart.options.axisX.title =
            this.groupBy === ChartGroupBy.day ? 'Daily' : 'Montly';
        this.chart.options.animationEnabled = true;
        this.chart.options.title.text = 'By office ' + model.officeName;
        this.chart.options.data = [
            this.createSalesData(model.items),
            this.createProgressData(model.items)
        ];
    }

    private createSalesData(items: IStatOfficePeriodChartItemModel[]) {
        return {
            type: 'column',
            showInLegend: true,
            name: 'Sales',
            dataPoints: items.map((x, i) => {
                return {
                    x: i,
                    label: x.date,
                    y: x.value,
                    color: '#375a7f',
                    indexLabelPlacement: 'inside',
                    indexLabelFontSize: 20,
                    indexLabelFontColor: 'blue'
                };
            })
        };
    }

    private createProgressData(items: IStatOfficePeriodChartItemModel[]) {
        return {
            type: 'spline',
            showInLegend: true,
            axisYType: 'secondary',
            name: 'Progress',
            dataPoints: this.mapProgressDataPoints(items)
        };
    }

    private mapProgressDataPoints(items: IStatOfficePeriodChartItemModel[]) {
        const res = [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.value > 0 || item.progress !== 0) {
                res.push({
                    x: i,
                    label: item.date,
                    y: item.progress,
                    indexLabelFontColor: 'red'
                });
            }
        }
        return res;
    }
}
